import { z } from 'zod';
import { HttpUrlSchema } from './hotels';

export const TriggerIntakeSchema = z.object({
  websiteUrl: HttpUrlSchema,
});
export type TriggerIntake = z.infer<typeof TriggerIntakeSchema>;

export const IntakeStatusSchema = z.object({
  hotelId: z.string().guid(),
  status: z.enum(['pending', 'running', 'done', 'failed']),
  startedAt: z.string().datetime().nullable(),
  finishedAt: z.string().datetime().nullable(),
  error: z.string().nullable(),
  pagesCrawled: z.number().int().nonnegative(),
  confidence: z.number().min(0).max(1).nullable(),
});
export type IntakeStatus = z.infer<typeof IntakeStatusSchema>;
